import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { FileLoadHistory } from './FileLoadHistory';

export class FileLoadHistoryResource extends FBaseService {
  public async getFileLoadHistory(fiId: string): Promise<FileLoadHistory[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/director/${fiId}/file-load-history`,
    );
    const rows: FileLoadHistory[] = response.data.data;
    return rows;
  }
}

export default FileLoadHistoryResource;
